/**
 * * Модель для добавления типов к проекту
 */
export default class UpsertTypeToNamespaceItem  {
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Описание
	 */
	Description!: string;
	/**
	 * * По умолчанию
	 */
	IsDefault: boolean = false;
	/**
	 * * Номер типа
	 */
	TypeId?: string;
	/**
	 * * Главный тип (нельзя удалить/изменить)
	 */
	IsMain: boolean = false;
	/**
	 * * Цвет
	 */
	Color!: string;
	/**
	 * * Порядковый номер
	 */
	Number!: number;
	constructor(obj?: Partial<UpsertTypeToNamespaceItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
